import {PlayerReduxDispatch, PlayerReduxState} from "../types";
import {getCurrentAction, getLevel} from "../selectors";
import {sessionPassStreamUserInputMutation} from "../graphql";
import {isAnyUserInputAction} from "../utils";
import {
  ChallengeMode,
  EducationSessionPassedResult,
  MutationEducationSessionPassStreamArgs,
} from "../../../schema";
import {analyticsSendEvent} from "../../../libs/analytics";
import {isMultipleChoiceUserInputAction, WithoutTypename} from "../../../types";
import handleUserAnswerResult from "../actionHandlers/handleUserAnswerResult";
import appendRpgUserTurnToDialogueHistory from "./appendRpgUserTurnToDialogueHistory";
import multipleSelectInput from "./multipleSelectInput";
import {ResponseTimeoutState} from "../../../types/ResponseTimeoutState";

export default function passUserInput({audioFileId, videoFileId, fileUploadData}: any) {
  return (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {
    const state = getState();
    const action = getCurrentAction(state);

    if (isMultipleChoiceUserInputAction(action)) {
      dispatch(multipleSelectInput({audioFileId, videoFileId, fileUploadData}));
      return;
    }

    if (!action || !isAnyUserInputAction(action)) {
      console.warn("passUserInput: wrong action");
      return;
    }

    analyticsSendEvent("playerPassAction", {
      sessionId: state.sessionId!,
      level: getLevel(state),
      actionId: action.id,
      audioUploadId: audioFileId,
      videoUploadId: videoFileId,
      actionType: action.__typename,
    });

    dispatch({type: "update", payload: {isRecognizing: true}});

    const uuid = fileUploadData.uuid ?? fileUploadData.id;

    state.client
      .mutate<
        {
          result: WithoutTypename<EducationSessionPassedResult>;
        },
        MutationEducationSessionPassStreamArgs
      >({
        mutation: sessionPassStreamUserInputMutation,
        variables: {
          uuid: uuid,
          sessionId: state.sessionId!,
          level: getLevel(state),
          actionId: action.id,
          audioUploadId: audioFileId,
          videoUploadId: videoFileId,
          recognizedText: fileUploadData.recognizedText,
          duration: fileUploadData.duration,
          sttError: fileUploadData.isError,
        },
      })
      .then((mutationResult) => {
        const state = getState();
        if (state.responseTimeoutState === ResponseTimeoutState.FINISHED) {
          return;
        }
        if (!mutationResult.data) {
          console.error("passUserInput: invalid mutation result");
          dispatch({
            type: "update",
            payload: {isRecognizing: false, responseTimeoutState: ResponseTimeoutState.ABORTING},
          });
          return;
        }

        if (state.responseTimeoutState === ResponseTimeoutState.STARTED) {
          dispatch({
            type: "update",
            payload: {responseTimeoutState: ResponseTimeoutState.ABORTING},
          });
        }

        const fromTimer = state.actionTimerAutoSubmit;
        if (fromTimer) {
          dispatch({type: "update", payload: {actionTimerAutoSubmit: false}});
        }

        const result = mutationResult.data.result;

        handleUserAnswerResult({result, state, dispatch,
          action, challengeMode: state.challenge.mode, uuid: uuid, fromTimer: fromTimer});

        if (state.challenge.mode === ChallengeMode.RPG_MODE) {
          dispatch(appendRpgUserTurnToDialogueHistory(result, action));
        }

        // Remove the init message, because the user has started lesson
        dispatch({
          type: "update",
          payload: {
            initAgentAction: null,
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: "update",
          payload: {isRecognizing: false, responseTimeoutState: ResponseTimeoutState.ABORTING},
        });

        console.error(err);
      });
  };
}
